import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { routes } from '../../route-list';

/**
 * Component that handles Auth0 error callbacks and redirects to appropriate pages
 */
export const AuthErrorHandler: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');

    // Check if this is an email verification error
    if (error === 'access_denied' && errorDescription?.toLowerCase().includes('verify your email')) {
      // Clean up the URL and redirect to email verification page
      const cleanPath = routes.EMAIL_VERIFICATION;
      history.replace(cleanPath);
    } else if (error) {
      // For other errors, clean up the URL but stay on current page
      const cleanPath = location.pathname;
      history.replace(cleanPath);
    }
  }, [location, history]);

  return null;
};
